import { RichText } from '../../utils'
import { IExtensibleProps, ILayout } from '../Hero'
import { IHeroImage, IVideo } from '../HeroWithCTA'

export { HeroForCareersPage } from './component'

export enum Mode {
  Normal = 'Normal',
  Compact = 'Compact',
}
export interface IProps extends IExtensibleProps {
  renderCta?: () => React.ReactNode
  footnote?: RichText
  layout: ILayout
  media?: IHeroImage | IVideo
  mode?: Mode
  withGradient?: boolean
}
